import { useIntl } from 'react-intl';
import { UrlParams } from '@sso/common-types';
import { Alert } from '@sso/components';
import { STATUS_CODES_MAP } from '@sso/core-utils';

type Props = {
  urlParams: UrlParams;
  ignoredStatusCodes?: Array<number>;
  formSubmissionStatusMessage?: string;
  id: string;
};

export const AccountCreateAlert = ({ id, urlParams, formSubmissionStatusMessage, ignoredStatusCodes = [] }: Props) => {
  const intl = useIntl();
  const statusCode = Number(urlParams.status);
  const isFormError = Boolean(formSubmissionStatusMessage);

  if (isFormError) {
    return (
      <Alert id={id} emphasis='critical' title={<></>} data-testid={id}>
        {formSubmissionStatusMessage}
      </Alert>
    );
  }

  if (STATUS_CODES_MAP[statusCode] != null && !ignoredStatusCodes.includes(statusCode)) {
    const { emphasis, message } = STATUS_CODES_MAP[statusCode] ?? {};
    return (
      <Alert id={id} emphasis={emphasis} title={<></>} data-testid={id}>
        {intl.formatMessage({ id: message })}
      </Alert>
    );
  }

  return null;
};
